import {CACHE_KEY} from './key';
import useImmutableSWR from 'swr/immutable';
import type {SWRResponse} from 'swr';
import type {LyricsPageQuery} from '@app/modules/graphql/generated';

export function useLyricsPageData(): SWRResponse<LyricsPageQuery> {
	// This hook is only used to return the cached value, returns null otherwise
	return useImmutableSWR(CACHE_KEY, null);
}
